import { Button, Col, Form, Image, Row } from "react-bootstrap";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "./FormComponent";
import { autoDisplayValue, formatDate, plusStringValue } from "../commons/FormatValue";
import { useState, useEffect, useRef } from "react";
import { getServiceRequest } from "../commons/ServiceRequest";
import { findItemInArray } from "../utils/ManageArray";
import PropTypes from "prop-types";

const InputSearch = ({
  field,
  fieldClassName = {
    inputRow: "justify-content-end",
    actionButton: "w-auto py-2"
  },
  moreButton,
  backButton,
  searchCallback,
  inputField,
  searchByField
}) => {
  const [data, setData] = useState({ Filter: { Array: [] } });
  const searchBtnRef = useRef(null);
  const clearBtnRef = useRef(null);
  const [Customer, setCustomer] = useState([]);
  const rowFilter = data?.Filter?.Array?.[0];
  const [searchData, setSearchData] = useState(inputField);
  const [optionData, setOptionData] = useState({});
  const fieldNameForSearch = searchByField?.name

  const handleChange = (name, value, queryService) => {
    let newData
    setData((prev) => {
      newData = {
        ...prev,
        Filter: {
          Array: [
            {
              ...prev.Filter?.Array[0],
              [name]: value || ""
            }
          ]
        }
      }
      return newData
    });

    if (fieldNameForSearch == name) {
      // searchCallback({ ...newData?.Filter?.Array[0], page: 1 });
      searchCallback(checkIsVal(newData?.Filter?.Array) ? { ...newData?.Filter?.Array[0], page: 1 } : "");
    } else {

      searchByField?.queryService(
        checkIsVal(newData?.Filter?.Array) ? { ...newData?.Filter?.Array[0] } : {}
      )
    }
  };
  function checkIsVal(Array) {
    let isVal = 0
    Array.map((el) => {
      const val = (Object.values(el))[0]
      if (val) isVal += 1
    })
    return isVal
  }

  const onSearchCallback = (event, name) => {
    event.preventDefault();
    if (name === "clear") {
      setData({ Filter: { Array: [] } });
      setSearchData(inputField);
      setDefaultOption();
      return searchCallback();
    } else {
      searchCallback({ ...data?.Filter?.Array[0], page: 1 }, 'submit');
      // searchCallback(data?.Filter?.Array[0] || {});
    }

    // searchCallback(searchData);
  };

  const setDefaultOption = () => {
    inputField?.forEach(({ name, labelName }) => {
      setOptionData((prev) => ({
        ...prev,
        [name]: []
      }));
    });
  };

  return (
    <>
      <Row
        className={
          fieldClassName?.inputRow ||
          "justify-content-center align-items-center"
        }
      >
        {field?.map(
          (
            {
              name,
              label,
              classNames,
              type,
              size,
              icon,
              options,
              filterBy,
              noneAsync,
              queryService,
              minKeywordLength,
              format,
              findValue,
              disabled,
              readOnly,
              required,
              onClick,
              placeholder,
              value,
              max,
              min,
              plusString,
              querySearch
            },
            idx
          ) => {
            const rowField = data?.Filter?.Array?.[0];
            const result =
              (name === "Attach_File" && formatFileName(rowField?.[name])) ||
              (plusString &&
                plusStringValue(
                  plusString?.plusValue,
                  plusString?.operator,
                  plusString?.data
                )) ||
              (format && format(rowField?.[name])) ||
              (findValue &&
                autoDisplayValue({
                  name,
                  type,
                  findValue: {
                    ...findValue,
                    value: rowField?.[findValue?.value || findValue?.key]
                  }
                })) ||
              rowField?.[name] ||
              "";

            const setDateTimeUpdate = (val) => {
              const dateTimeUpdate =
                name === "Install_Doc_Date" ? dateTimeInform : dateTime;
              const fieldUpdate = label !== "" ? "date" : "time";
              const updatedDateTime = { ...dateTimeUpdate, [fieldUpdate]: val };

              name === "Install_Doc_Date"
                ? setDateTimeInform(updatedDateTime)
                : setDateTime(updatedDateTime);
            };

            return (
              <Col
                key={idx}
                sm={size === null ? null : size || 3}
                className={classNames?.col}
              >
                {type ? (
                  type === "button" ? (
                    <Button
                      variant="outline-secondary"
                      className="mt-2 p-2 rounded-circle"
                      disabled={disabled}
                      onClick={onClick}
                      style={{ width: "45px" }}
                    >
                      <Image src={icon?.src} alt={icon?.alt} />
                    </Button>
                  ) : (
                    <div className={!required && "noValidGreen"}>
                      <FloatingControlComponent
                        type={type}
                        name={name}
                        label={label}
                        placeholder="โปรดระบุ"
                        disabled={disabled}
                        readOnly={readOnly}
                        required={required}
                        className={classNames}
                        onChange={({ target }) => {
                          ["Install_Doc_Date", "Job_Cus_Date"].includes(name)
                            ? setDateTimeUpdate(target.value)
                            : handleChange(name, target.value, label);
                        }}
                        value={value ? value : result}
                        max={type == "date" && max && formatDate(rowField?.[max], 'YYYY-MM-DD')}
                        min={type == "date" && min && formatDate(rowField?.[min], 'YYYY-MM-DD')}
                      />
                    </div>
                  )
                ) : (
                  <div className={!required && "noValidGreen"}>
                    <SearchSelectComponent
                      floatingClass="mb-1"
                      labelField={label}
                      placeholder={placeholder || "ทั้งหมด"}
                      noneAsync={noneAsync}
                      disabled={disabled}
                      queryService={queryService}
                      filterBy={filterBy}
                      options={
                        querySearch ? [{ value: querySearch[name], label: querySearch[name] }]
                          : options || []
                      }
                      minKeywordLength={minKeywordLength}
                      onChange={(selected) => {
                        handleChange(name, selected?.value || null);
                        if (querySearch) searchCallback("", "clear")
                      }}
                      isInvalid={required}
                      value={`${!querySearch ? result : querySearch[name]}`}
                    // value={(findValue && displayValue) || value}
                    />
                  </div>
                )}
              </Col>
            );
          }
        )}

        {fieldClassName?.actionButton && (
          <Col
            sm={fieldClassName.actionRowSize ?? 3}
            className={fieldClassName.actionButton}
          >
            {moreButton && moreButton}

            <Button
              ref={searchBtnRef}
              type="submit"
              variant="success"
              disabled={fieldClassName.actionDisabled?.start}
              className="me-2 py-2 px-4 text-dark rounded-pill"
              onClick={(event) => onSearchCallback(event)}
            >
              {fieldClassName?.actionName?.start || "ค้นหา"}
            </Button>
            <Button
              ref={clearBtnRef}
              variant="outline-secondary"
              disabled={fieldClassName.actionDisabled?.end}
              className="py-2 px-4 text-dark rounded-pill"
              onClick={(event) => onSearchCallback(event, "clear")}
            >
              {fieldClassName?.actionName?.end || "ล้างการค้นหา"}
            </Button>

            {backButton && (
              <Button
                variant="outline-secondary"
                className="ms-2 px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                onClick={() =>
                  navigate(backButton.path, {
                    state: { name: backButton.state }
                  })
                }
              >
                ย้อนกลับ
              </Button>
            )}
          </Col>
        )}
      </Row>
    </>
  );
};

InputSearch.propTypes = {
  field: PropTypes.array,
  fieldClassName: PropTypes.object,
  moreButton: PropTypes.element,
  backButton: PropTypes.string,
  searchCallback: PropTypes.func,
  inputField: PropTypes.array,
  searchByField: PropTypes.object
};

export default InputSearch;
